/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PricingPurchaseOptionQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PricingPurchaseOptionQueryOperator");
    }

    getFixupPrototypeFunction() { return PricingPurchaseOptionQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PricingPurchaseOptionQueryOperator>): PricingPurchaseOptionQueryOperator {
        let obj = Object.assign(new PricingPurchaseOptionQueryOperator(), model);
        PricingPurchaseOptionQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PricingPurchaseOptionQueryOperator>): PricingPurchaseOptionQueryOperator {
        if (!model) return null;
        return PricingPurchaseOptionQueryOperator.newInstance(<PricingPurchaseOptionQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PricingPurchaseOptionQueryOperator) {
        if (!obj) return;

        models.PricingPurchaseOptionQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PricingPurchaseOptionQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PricingPurchaseOptionQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Pricing purchase options to include
     */
    pricing_purchase_options: Array<string>;

}
